// extracted by mini-css-extract-plugin
export default {"actions-toolbar":"DocumentsActions_actions-toolbar__rp4zC","action-toolbar-button":"DocumentsActions_action-toolbar-button__HFnsj"};